module.exports = __webpack_public_path__ + "img/pay-weixin-eg.47d7c1fd.jpg";